export const RACING_SPECIAL = {
    cacheInterval: 5 * 60 * 1000, // 5 min
    cacheName: 'racingSpecialsEvents',
};
